import React from 'react'
import Vars from 'Consts/vars'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'

const TypeFour = (props) => (
  <div className={`fdn-article-card-desktop-${props.type}`}>
    <div className="article-content">
      <a href={props.article.url} className="article-image">
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
        >
          <ImageFallback
            src={props.article.image}
            alt={props.article.title}
            objectFit="cover"
            layout="fill"
            priority
            quality={80}
            fallbackSrc={Vars.imageBrokenDefault.rectangle}
          />
        </div>
      </a>
      <div className="article-title">
        <a className="title-anchor" href={props.article.url}>
          {props.article.title}
        </a>
        {props.article.author.fullname && (
          <p className="title-p">
            by
            <a className="article-author-italic" href={props.url_author}>
              {props.article.author.fullname}
            </a>
          </p>
        )}
      </div>
    </div>
    <style jsx>
      {`
        .fdn-article-card-desktop-${props.type} {
          display: flex;
          flex-flow: column;
          border: none;
          word-break: break-word;
          border-bottom: ${props.border_bottom ? `1px solid #DFE3E8` : ``};
          padding-bottom: 20px;
        }
        .fdn-article-card-desktop-${props.type} .article-content {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-auto-rows: minmax(min-content, max-content);
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-image {
          width: 100px;
          height: 100px;
          padding: 5px 0;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-image
          .article-image-source {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-image:hover {
          ${Vars.HOVER_TYPE.IMAGE}
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title {
          padding-left: 15px;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title
          .title-anchor {
          font-family: ${props.font_title};
          font-weight: 600;
          font-size: 20px;
          color: #000;
          line-height: 1.5;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title
          .title-anchor:hover {
          ${Vars.HOVER_TYPE.TEXT_PINK}
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title
          .title-p {
          font-family: Roboto;
          font-size: 12px;
          font-weight: 400;
          color: #919eab;
          margin: 10px 0 0 0;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title
          .title-p
          .article-author-italic {
          font-family: Roboto;
          font-size: 12px;
          font-weight: 700;
          font-style: italic;
          text-transform: capitalize;
          margin-left: 3px;
          color: #919eab;
          text-decoration: none;
        }
        .fdn-article-card-desktop-${props.type}
          .article-content
          .article-title
          .title-p
          .article-author-italic:hover {
          ${Vars.HOVER_TYPE.TEXT_PINK}
          cursor: pointer;
        }
      `}
    </style>
  </div>
)

export default TypeFour
